import { render, staticRenderFns } from "./Conclusiones.vue?vue&type=template&id=beb4c56e"
import script from "./Conclusiones.vue?vue&type=script&lang=js"
export * from "./Conclusiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports